import React from 'react';
import PropTypes from 'prop-types';

import './Alert.css';

class Alert extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
  };

  render() {
    return (
      <div className="Alert">
        <div className="Alert__title">{this.props.title}</div>
        <div className="Alert__message">
          <span className="Alert__message__text">{this.props.message}</span>
        </div>
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/Alert.js